// src/components/WorkflowNodeTemplates.js

import React, { useState } from 'react';
// import { CgLayoutGrid } from 'react-icons/cg';
import { FaTrashAlt, FaEdit, FaPlus, FaPen, FaPenAlt } from 'react-icons/fa'; // 3-dot vertical menu icon
import { AiOutlineHome } from 'react-icons/ai';
import shadows from '@mui/material/styles/shadows';
// import { MdOutlineRoom, MdOutlineCheckCircle, MdOutlineAddBox } from "react-icons/md";

function formatNodeType(nodeType) {
  // Step: Remove 'Node' from the end if it exists
  let trimmedString = nodeType.endsWith('Node')
    ? nodeType.slice(0, -4)
    : nodeType;
  // Split the string at uppercase letters and join with spaces
  // This regex matches positions before uppercase letters
  const formattedString = trimmedString.replace(/([A-Z])/g, ' $1').trim();

  return formattedString;
}
const WorkflowNodeTemplates = ({
  title,
  type,
  handleClick,
  active,
  status,
  highlight,
}) => {
  const [isActive, setIsActive] = useState(true);
  const toggleChange = (e) => {
    e.stopPropagation();
    setIsActive(!isActive);
  };
  // console.log(status);

  const [selectedWidget, setSelectedWidget] = useState(null);
  console.log(`/images/Nodes/${type}Icon.svg`);
  return (
    <div
      // onClick={handleClick}
      style={{
        padding: '0px',
        background: '#ffffff',
        border: '1px solid #e6e6e6',
        border:
          status != 'publish' ? '1px solid #333' : '2px solid rgb(14 232 0)',
        boxShadow: '0px 1px 0px #00000029',
        borderRadius: '6px',
        marginBottom: '10px',
        cursor: 'pointer',
        position: 'relative',
        // opacity: isActive ? '1' : '0.5'
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '2px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'capitalize',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '40px',
              height: '40px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={`/images/Nodes/${type}Icon.svg`}
              alt={`${type} Icon`}
              width={60}
              style={{
                position: 'absolute',
                width: '60px',
                height: '60px',
                maxWidth: 'none',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          </div>
          <label
            style={{ fontWeight: 'normal', margin: '0', paddingLeft: '10px' }}
          >
            {formatNodeType(title)}
          </label>
          {/* <i>{status}</i> */}
          {/* <div style={{ fontSize: '12px', color: '#888' }}>{type}</div> */}
        </div>
        {/* Actions */}

        <div className="flex items-center space-x-2 gap-2 gjs-p-4">
          {/* <FaTrashAlt color="#f00000" className="text-red-500 cursor-pointer" /> */}
          <span onClick={handleClick}>
            {active ? (
              <FaPen color="var(--primary-color)" />
            ) : (
              <FaPlus color="var(--primary-color)" />
            )}
          </span>
        </div>
        <div style={{ display: 'none', alignItems: 'center', gap: '20px' }}>
          {/* Active toggle button */}
          {/* { isActive ? 'Active' : 'Inactive' } */}

          <div
            style={{
              position: 'relative',
              display: 'inline-block',
              width: '34px',
              height: '20px',
            }}
            onClick={toggleChange}
          >
            <span
              style={{
                position: 'absolute',
                cursor: 'pointer',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                backgroundColor: isActive ? '#4caf50' : '#ccc',
                transition: '.4s',
                borderRadius: '34px',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  content: '""',
                  height: '14px',
                  width: '14px',
                  borderRadius: '50%',
                  left: isActive ? '18px' : '4px',
                  bottom: '3px',
                  backgroundColor: 'white',
                  transition: '.4s',
                }}
              ></span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowNodeTemplates;
